import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllBoardingLines = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/boarding-lines',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveBoardingLine = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/boarding-lines',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateBoardingLine = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/boarding-lines/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteBoardingLine = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/boarding-lines/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllBoardingLines,
  saveBoardingLine,
  deleteBoardingLine,
  updateBoardingLine,
}
